// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"164":"terms","594":"about","957":"privacy"}[chunkId] + "." + {"164":"fbc9579e","594":"0295bd0a","957":"4eca5e10"}[chunkId] + ".js";
};